// Module
var code = "<react-component name=\"ManageWebsiteBusinessDetails\" props=\"{save: save, data: website, websiteUrl: websiteUrl()}\"></react-component>\n";
// Exports
module.exports = code;